<div class="driver-select-wrapper" [class.open]="isDropdownOpen" [class.disabled]="disabled" [class.dropup]="dropup" [class.invalid-driver]="isInvalidDriver">
    <div class="select-trigger" (click)="toggleDropdown()">
        <span class="placeholder" *ngIf="!selectedLabel">{{ placeholder }}</span>
        <span class="selected-value" *ngIf="selectedLabel">{{ selectedLabel }}</span>
        <div class="custom-arrow"></div>
    </div>

    <div class="dropdown-list-container" *ngIf="isDropdownOpen">
        <div class="dropdown-item" *ngFor="let opt of options" (click)="selectOption(opt)">
            <ng-container *ngIf="opt.id && opt.id !== 'all'; else specialOption">
                <span class="status-dot-css"
                    [class.online]="opt.isOnline || opt.is_online || opt.activity_status === 'True'"
                    [class.warning]="opt.is_virtual_user || opt.isSpecial">
                </span>
                <span class="driver-name-text">{{ opt.first_name }} {{ opt.last_name }}</span>
                <span class="hd-tag" *ngIf="opt.headdriver">&nbsp;{{ opt.headdriver }}</span>
            </ng-container>
            <ng-template #specialOption>
                <span class="driver-name-text">{{ opt.id === 'all' ? 'All Drivers' : 'None' }}</span>
            </ng-template>
        </div>
    </div>
</div>